import { render } from "./BerufsBilder.vue?vue&type=template&id=98190f2e"
import script from "./BerufsBilder.vue?vue&type=script&lang=ts"
export * from "./BerufsBilder.vue?vue&type=script&lang=ts"

import "./BerufsBilder.vue?vue&type=style&index=0&id=98190f2e&lang=scss"
script.render = render

export default script